import client from "../client"

export const submitAnswer = async ({ motibellNo, motibellQuizNo, answer }) => {
	const form = { answer }
	const response = await client.post(`/motibells/${motibellNo}/quizzes/${motibellQuizNo}`, form)

	return response.data
}
